"use client";

import type { ReactElement } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function AttachPickTooltip({
  url,
  children,
  disabled,
}: {
  url: string;
  children: ReactElement;
  disabled?: boolean;
}) {
  return (
    <Tooltip disabled={disabled}>
      <TooltipTrigger render={children} />
      <TooltipContent
        side="top"
        className="block max-w-[360px] whitespace-normal break-all text-left leading-relaxed shadow-md"
      >
        {url}
      </TooltipContent>
    </Tooltip>
  );
}
